/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Player_Vekn_IdInputs */



/**
* | output |
* | --- |
* | "VEKN ID (optional)" |
*
* @param {Offline_Player_Vekn_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_player_vekn_id = /** @type {((inputs?: Offline_Player_Vekn_IdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Player_Vekn_IdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID VEKN (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID VEKN (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("ID VEKN (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID VEKN (opzionale)")
	return /** @type {LocalizedString} */ ("VEKN ID (optional)")
});